var map = {
	"./MTN-Momo-e1584721116128.jpg": 8287,
	"./Moneytrans_Logo.jpg": 4916,
	"./Orange-Money-logo.jpg": 6219,
	"./Prudential-Belife-Insurance-recrute-pour-plusieurs-postes-02-Novembre-2023.jpg": 5071,
	"./Sigue.png": 4148,
	"./TransFast-featured-Image.png": 1384,
	"./WU_Prim_CMYK.jpg": 7700,
	"./avis-carte-paytop.jpg": 6861,
	"./logo-ce-2023.jpg": 9739,
	"./moneugram.jpg": 1536,
	"./ria.jpg": 9882,
	"./small-world-financial-service-logo-7E1D2B6258-seeklogo.com.png": 3314,
	"./wafa.png": 9806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2721;